import type { FC } from 'react';
import { useEffect } from 'react';

import { useIsSellerCommunicationsAllowed } from 'Features/SellerCommunications/hooks/useIsSellerCommunicationsAllowed';
import { infoService } from 'Features/SellerCommunications/services';

import { Modal } from '../Modal';

interface SellerCommunicationsModalProps {
	enquiries?: { enquiryId: number }[];
	updatedAt: number;
}

export const SellerCommunicationsModal: FC<SellerCommunicationsModalProps> = ({ enquiries, updatedAt }) => {
	const isAllowed = useIsSellerCommunicationsAllowed();

	useEffect(() => {
		if (isAllowed && enquiries?.length) {
			infoService.getCommunicationInfo(enquiries.map(({ enquiryId }) => enquiryId));
		}
	}, [enquiries, isAllowed, updatedAt]);

	return isAllowed ? <Modal /> : null;
};
